// extracted by mini-css-extract-plugin
export default {"product":"fY","image_carousel":"gY","main_gallery":"hY","personalized_badge":"iY","greens_badge":"jY","arrows":"kY","slide":"lY","thumbnail_gallery":"mY","swiper-slide":"nY","learn_more":"oY","product_info":"pY","description_wrapper":"qY","checklist":"rY","checklistItem":"sY","delivery_freq":"tY","tooltip_button":"uY","key_benefits":"vY","benefit_item":"wY","ingredients":"xY","ingredient_item":"yY","active_slide":"zY","benefits_list":"AY","checkmark":"BY"};
    if(module.hot) {
      // 1730991511735
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  